<div [ngStyle]="currentStyle">{{ date | daysAgo }}</div>
